import React, { useState } from 'react';

import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../hooks/useTranslation';
import { EikaModal } from '../EikaModal';

import './EffectiveInterestInfo.scss';

const EffectiveInterestInfo: React.FC = () => {
    const translated = useTranslation();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <IconButton
                icon={IconTypes.INFO_24}
                onClick={() => setShowModal(true)}
                screenReaderText={translated.effectiveInterestInfo.title}
            />
            <EikaModal
                setOpen={setShowModal}
                open={showModal}
                title={translated.effectiveInterestInfo.title}
                className="effective-interest-info-modal"
                contentShouldStretch
            >
                <p className="typography-paragraph">
                    {translated.effectiveInterestInfo.description1}
                    <br />
                    {translated.effectiveInterestInfo.description2}
                </p>
                <div className="effective-interest-info-button-container">
                    <StandardButton onClick={() => setShowModal(false)}>{translated.close}</StandardButton>
                </div>
            </EikaModal>
        </>
    );
};

export default EffectiveInterestInfo;
